import { CommonActionTypes } from "../../action-types";

const vaspList = JSON.parse(localStorage.getItem("vaspList"));

const initialState = {
  vaspList: vaspList ? vaspList : null,
};

export default function allVASPListReducer(state = initialState, action) {
  switch (action.type) {
    case CommonActionTypes.GET_VASP_LIST:
      return {
        vaspList: action.payload,
      };
    default:
      return state;
  }
}
